export default __webpack_public_path__ + "static/media/Ellipse 13.aa217448.png";